// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4dcd4651","239":"376a866a","453":"7468e757","455":"d1f8b0db"}[chunkId] + ".chunk.js";
};